module.exports = __webpack_public_path__ + "assets/5644dcab35a71de932bfa3b67c9e5e8f.png";